import { useGetLeagueBoardQueryState } from '@/api/queries/league';
import { useGetUserPartnersQueryState } from '@/api/queries/user';

import { getUserLeagueScore } from '../lib/league';

import { useSelectorRef } from './selector-ref';

interface UseSessionFinishedDataReturnType {
  (): {
    user_balance: Record<string, unknown>;
    star_points: number;
    t_gems_spend: number;
    partners: number;
    arena_score: number;
    session_length: number;
    level: number;
    vip: boolean;
    capitalizations: number;
    wallet_connect: boolean;
  };
}

const useSessionFinishedData = (): UseSessionFinishedDataReturnType => {
  const balance = useSelectorRef((state) => state.user.user?.balance);
  const level = useSelectorRef((state) => state.user.user?.level);
  const vip = useSelectorRef((state) => state.user.user?.VIP);
  const partnersData = useGetUserPartnersQueryState({ page: 1 });
  const leagueData = useGetLeagueBoardQueryState();
  const capitalization = useSelectorRef(
    (state) => state.user.extendedInfo?.totalEmpireValue,
  );
  const tonWalletAddress = useSelectorRef(
    (state) => state.user.user?.tonWalletAddress,
  );

  return () => {
    const startPointBalance = Number(
      sessionStorage.getItem('start-point-balance') || '0',
    );
    const tgemSpend = Number(sessionStorage.getItem('tgem-spend') || '0');

    return {
      user_balance: balance.current || {},
      t_gems_spend: tgemSpend,
      partners: partnersData.data?.total || 0,
      arena_score: getUserLeagueScore(leagueData.data) || 0,
      star_points: balance.current?.point
        ? balance.current.point - startPointBalance
        : 0,
      session_length: Math.floor(performance.now() / 1000),
      level: level.current || 0,
      vip: !!vip.current,
      capitalizations: capitalization.current || 0,
      wallet_connect: !!tonWalletAddress.current,
    };
  };
};

export { useSessionFinishedData };
